import script from "./CheckInReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckInReserva.vue?vue&type=script&setup=true&lang=js"

import "./CheckInReserva.vue?vue&type=style&index=0&id=60e732b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e732b3"]])

export default __exports__